import { MenuComponentProps } from 'piral'
import * as React from 'react'

export default function SettingsMenu(props: MenuComponentProps) {
    return (
        <sp-action-menu force-popover quiet label="settings">
            <sp-icon-settings slot="icon"></sp-icon-settings>
            <props.piral.Extension name="settings-menu-extension"></props.piral.Extension>
        </sp-action-menu>
    )
}
